// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f3a15d64","455":"188d9742","977":"be1d199e"}[chunkId] + ".chunk.js";
};